import * as React from 'react';
import { useScrollPosition } from './useScrollPosition';

interface UseRestoreScrollPositionProps {
  condition: boolean;
}

export const useRestoreScrollPosition = ({
  condition
}: UseRestoreScrollPositionProps) => {
  const isConditionRef = React.useRef(false);
  const scrollPositonRef = React.useRef(0);
  const scrollPosition = useScrollPosition();

  React.useEffect(() => {
    if (condition) isConditionRef.current = true;
    if (!condition && isConditionRef.current) {
      isConditionRef.current = false;
      window.scrollTo(0, scrollPositonRef.current);
    }
    if (scrollPosition > 0) scrollPositonRef.current = scrollPosition;
  }, [scrollPosition, condition]);
};
